import type { MessageTemplateContextShape } from '@post-office/shared-contracts/types';

export type MessageTemplateContext = MessageTemplateContextShape<{
	message: string;
	link?: {
		href: string;
		text: string;
	};
}>;

export const assertMessageTemplateContext = (value: unknown): MessageTemplateContext => {
	if (
		typeof value !== 'object' ||
		value === null ||
		!('message' in value) ||
		typeof value.message !== 'string'
	) {
		throw new TypeError('Expected a test-message-config-sets message context');
	}

	if (
		'link' in value &&
		value.link !== undefined &&
		(typeof value.link !== 'object' ||
			value.link === null ||
			!('href' in value.link) ||
			typeof value.link.href !== 'string' ||
			!('text' in value.link) ||
			typeof value.link.text !== 'string')
	) {
		throw new TypeError('Expected test-message-config-sets link text and href strings');
	}

	return value as MessageTemplateContext;
};
